import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
    SeqOrderStatusEnum,
    SeqReactionStatusEnum,
} from '@app/features/order-harness/_core/interfaces/seq/seq-order.enums';

export function seqOrderStatusNotComputed(): ValidatorFn {
    return (control: AbstractControl) => {
        if (control.value === null) {
            return { seqOrderStatusIsComputed: true };
        }
        if (control.value === SeqOrderStatusEnum.ALL) {
            return { seqOrderStatusIsComputed: true };
        }
        if (control.value === SeqOrderStatusEnum.ACTION_REQUIRED) {
            return { seqOrderStatusIsComputed: true };
        }
        if (control.value === SeqOrderStatusEnum.PARTIALLY_COMPLETED) {
            return { seqOrderStatusIsComputed: true };
        }

        return null;
    };
}

export function seqReactionStatusNotComputed(): ValidatorFn {
    return (control: AbstractControl) => {
        if (control.value === null) {
            return { seqReactionStatusIsComputed: true };
        }
        if (control.value === SeqReactionStatusEnum.ACTION_REQUIRED) {
            return { seqReactionStatusIsComputed: true };
        }

        return null;
    };
}

export function wellplateFormat(): ValidatorFn {
    const pattern = /^(T|E|B)[A-Z0-9]{2,14}$/;

    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (typeof value !== 'string' || !pattern.test(value)) {
            return { invalidWellplateFormat: true };
        }

        return null;
    };
}

export function emptyInputValidator(inputValue: FormControl): ValidationErrors | null {
    if (!inputValue.value) {
        return null;
    }
    return inputValue!.value.trim() !== '' ? null : { emptyInput: true };
}

export const SeqCustomValidators = {
    seqOrderStatusNotComputed,
    seqReactionStatusNotComputed,
};

export const CustomValidators = {
    wellplateFormat,
    emptyInputValidator,
};
